import Pusher from 'pusher-js';

const pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY || '740b2925ad2bee7c9f5d', {
  cluster: 'ap1'
});

export default pusher;